import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import {
	IPropsGetPaymentStatusQuery,
	IResponseGetPaymentStatusQuery,
} from "./types"
import { GetWebSiteBuilderPaymentStatus } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getPaymentStatusQuery(
	{ ...rest }: IPropsGetPaymentStatusQuery,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetPaymentStatusQuery> =
			await apiPrivate.get(`${GetWebSiteBuilderPaymentStatus}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetPaymentStatusQuery(
	data: IPropsGetPaymentStatusQuery,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetPaymentStatusQuery,
					unknown,
					IResponseGetPaymentStatusQuery
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETPAYMENTSTATUSQUERY, ...Object.values(data)],
		queryFn: () => getPaymentStatusQuery(data, apiPrivate),
		...options,
	})
}
